import { useAppStore } from '../../store/useAppStore.js';
import { StageFeedback } from './ReviewWaitingScreen.js';

export function RipplingOnboardingScreen() {
  const stageFeedback = useAppStore((s) => s.stageFeedback);
  return (
    <div className="max-w-md mx-auto card p-7 lg:p-10 has-grain animate-fade-up">
      <h2 className="h-card mb-2">Complete your onboarding at Rippling</h2>
      <p className="hint">
        Your intro video is approved. Check your email for an invitation from Rippling, where you'll
        complete your background check and payment forms.
      </p>
      <StageFeedback note={stageFeedback} />
      <p className="mt-4 text-[0.85rem] text-ink-600 dark:text-ink-300">
        Once Rippling has everything, an ASL Go reviewer gives your application a final look. We'll
        email you at each step — there's nothing to do here in the meantime.
      </p>
      <p className="mt-3 text-[0.78rem] text-ink-500">This usually takes 1–5 business days.</p>
    </div>
  );
}
